import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "text"]
  static values = { requestId: String }

  connect() {
    if (this.textTarget.value.trim() !== "") {
      this.#autoResize()
      return
    }

    const key = `draft-message-${this.requestIdValue}`
    try {
      const raw = localStorage.getItem(key)
      if (!raw) return

      const draft = JSON.parse(raw)
      const oneDay = 24 * 60 * 60 * 1000
      if (!draft.text || draft.text.trim() === "" || Date.now() - draft.savedAt > oneDay) return

      this.textTarget.value = draft.text
      this.containerTarget.classList.remove("hidden")
      this.#autoResize()
    } catch {
      // ignore
    }
  }

  #autoResize() {
    const el = this.textTarget
    el.style.height = "auto"
    el.style.height = `${el.scrollHeight}px`
  }

  clearStorage() {
    try {
      localStorage.removeItem(`draft-message-${this.requestIdValue}`)
    } catch {
      // ignore
    }
  }
}
